import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import { makeStyles } from "@material-ui/core/styles";

const Header = ({ text, onClose }) => {
  const classes = useStyles();
  return (
    <Container>
      <Typography className={classes.root}>{text}</Typography>
      <IconButton
        disableRipple
        className={classes.iconButton}
        onClick={onClose}
      >
        <ClearIcon className={classes.icon} />
      </IconButton>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  background: var(--surface-50);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3em 0;
  border-bottom: 1px solid var(--surface-300);
`;

const useStyles = makeStyles((theme) => ({
  root: {
    color: "var(--text-primary)",
    marginLeft: "1em",
  },
  icon: {
    color: "var(--teal-700)",
  },
  iconButton: {
    marginRight: "0.3em",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },
    "&:active": {
      backgroundColor: "var(--teal-300)",
    },
    "&:focus": {
      outline: "1px solid var(--teal-500)",
      outlineOffset: "4px",
    },
    "&:disabled": {
      opacity: 0.6,
    },
  },
}));
